// extracted by mini-css-extract-plugin
export default {"successModal":"CheckoutSuccessModal_successModal__Bv+HA"};